module.exports = __webpack_public_path__ + "img/img14.b89f1e46.png";